import genUUID from "@/utils/gen-uuid";
import { useCallback, useEffect, useState } from "react";
import ReconnectingWebSocket from "reconnecting-websocket";
import mitt, { Emitter } from "mitt";

export interface SystemStatus {
    rws: ReconnectingWebSocket
    resetRws: (value: ReconnectingWebSocket) => void
}

/**
 * 系统存储
 * @returns 
 */
export function useSystemService() {
    const [rws, setRws] = useState<ReconnectingWebSocket>(null);

    /**
     * 重置websocket
     */
    const resetRws = useCallback((value: ReconnectingWebSocket) => {
        if (rws != null) {
            rws.close();
        }
        setRws(value);
    }, [])

    return {
        rws,
        resetRws,
    } as SystemStatus
}
